import React from 'react'
import { Link } from 'widgets-for-react'
import { pushDatalayer } from '../../seo/datalayer'
import { CMSFooterItem } from '../cmsPage.state'
import { getTargetBlankProps, isLinkExternal, stripUrlToPath } from '../utils/link'
import i18next from 'i18next'
import { DisplayType } from '../header/siteHeader/cmsSiteHeader.state'
import { SharingLayout } from '../header/pageHeader/sharing.layout'
import { FormControls } from '../../../../Shared/Frontend/forms'

const t = i18next.getFixedT(null, "Footer")

export const CmsFooterLayout = {
  FooterWrapper: (props: { hideFooterInfo: boolean, children?: React.ReactNode }): JSX.Element => (
    <footer id="a11y-footer" className="sitefooter sf">
      <div className="sf__inner">
        {!props.hideFooterInfo &&
          <div className="sfs sitefooter-sharing">
            <div className="sfs__inner ls-container ls-spacing ls-gutter">
              <p className='sfs__title title--s'>{i18next.t('General:ShareTitle')}</p>
              <SharingLayout.ShareItems />
            </div>
          </div>
        }

        <nav className="sf__nav" aria-label={t('LabelA11Y')}>
          <div className="sf__navinner">
            {props.children}
          </div>
        </nav>
      </div>
    </footer>
  ),
  Wrapper: (props: { children?: React.ReactNode }): JSX.Element => (
    <div className='sf__topnav'>
      <div className='sf__topnav-inner ls-container ls-gutter'>
        {props.children}
      </div>
    </div>
  ),
  footer2Level: (props: { children?: React.ReactNode, items: CMSFooterItem[], displayType: DisplayType }): JSX.Element => (
    <div className='sf__menus'>
      {props.items
        ?.sort((a, b) => a.Weight - b.Weight)
        .map((menuItem, index) => {
          return (
            <CmsFooterLayout.SubMenuItemWrapper key={`fm-sm-${index.toString()}-${props.displayType}`}>
              <CmsFooterLayout.SubMenuTitle title={menuItem.Title} />
              <CmsFooterLayout.SubMenuList key={`fm-sl-${index.toString()}`}>
                {menuItem.Children.map((subMenuItem, k) => {
                  return (
                    <CmsFooterLayout.ItemLink key={`fm-il-${index.toString()}-${k}`} title={subMenuItem.Title} url={subMenuItem.Url} />
                  )
                })}
              </CmsFooterLayout.SubMenuList>
            </CmsFooterLayout.SubMenuItemWrapper>
          )
        })}

      {props.children}
    </div>
  ),
  Newsletter: (props: {email?: string, updateEmailInput: (input: string) => void, submitEmail: () => void}) => (
    <div className='sf__newsletter'>
      <p className='sf__menutitle title--s'>{t("NewsletterTitle")}</p>
      <form
        className='sf__newsletter-form'
        onSubmit={e => {
          e.preventDefault()
          props.submitEmail()
        }}
      >
        <FormControls.FormItemInGroup
          key={'sf__mail'}
          type='text'
          controlId={'sf__mail'}
          inputMode='email'
          label={t("NewsletterLabelSRT")}
          disabled={false}
          required={false}
          value={props.email}
          placeholder={t("NewsletterPlaceholder")}
          onChange={e => props.updateEmailInput(e)}
        />
        <button className='button button--tertiary button--on-red'>
          <span className="button__label">{t("NewsletterButton")}</span>
        </button>
      </form>
    </div>
  ),
  SubMenuItemWrapper: (props: {children?: React.ReactNode }): JSX.Element => (
    <div className='sf__menu'>{props.children} </div>
  ),
  SubMenuTitle: (props: { title: string }) => {
    return (
      <p className='sf__menutitle title--s'>{props.title}</p>
    )
  },
  SubMenuList: (props: { children: JSX.Element[] }) => {
    return (
      <ul className='sf__menulist'>{props.children}</ul>
    )
  },
  SocialItemsWrapper: () => {
    return (
      <>
        {itemSocial(t("InstagramURL"), t("Instagram"), 'instagram')}
        {itemSocial(t("LinkedInURL"), t("LinkedIn"), 'linkedin')}
        {itemSocial(t("FacebookURL"), t("Youtube"), 'facebook')}
        {itemSocial(t("YoutubeURL"), t("Youtube"), 'youtube')}
      </>
    )
  },
  ItemLink: (props: { title: string; url: string, children?: JSX.Element | string }) => {
    return (
      <li className="sf__menuitem">
        {isLinkExternal(props.url) ? (
          <a className="sf__menulink" href={props.url}>
            {props.children ? props.children : props.title}
          </a>
        ) : (
          <Link
            to={stripUrlToPath({ title: props.title, url: props.url })}
            onClick={() => {
              pushDatalayer({
                event: 'event.gtm',
                category: 'footer_button',
                label: window.location.href,
                action: props.title,
              })
            }}
            className="sf__menulink"
          >
            {props.children ? props.children : props.title}
          </Link>
        )}
      </li>
    )
  },
  BottomNav: () => (
    <div className='sf__bottomnav text--s'>
      <div className='sf__bottomnav-inner ls-container--l ls-spacing ls-gutter'>
        <ul className='sf__legal'>
          <CmsFooterLayout.BottomNavItem itemKey={'bm-i-1'} title={t("Privacy")}  url={t("PrivacyURL")} />
          <CmsFooterLayout.BottomNavItem itemKey={'bm-i-2'} title={t("Cookies")}  url={t("CookiesURL") }/>
          <CmsFooterLayout.BottomNavItem itemKey={'bm-i-3'} title={t("Behaviour")}  url={t("BehaviourURL")} />
        </ul>

        <ul className='sf__social'>
          <CmsFooterLayout.SocialItemsWrapper />
        </ul>

        <ul className='sf__logos'>
          <li className='sr-text'>{t("partnersA11Y")}</li>
          {itemPartner(t("AnbiURL"), t("Anbi"), 'anbi', 43)}
          {itemPartner(t("CBFURL"), t("CBF"), 'cbf', 66)}
          {itemPartner(t("NationalePostcodeLoterijURL"), t("NationalePostcodeLoterij"), 'npl', 52)}
          {itemPartner(t("VriendenLoterijURL"), t("VriendenLoterij"), 'vl', 80)}
          {itemPartner(t("NederlandseLoterijURL"), t("NederlandseLoterij"), 'nl', 128)}
        </ul>
      </div>
    </div>
  ),
  BottomNavItem: (props: { itemKey: string, title: string; url: string }) => {
    return (
      <li className='sf__legalitem' key={props.itemKey}>
        <a href={props.url} className='sf__legallink'>{props.title}</a>
      </li>
    )
  }
}

export const itemSocial = (url: string, srText: string, slug: string): JSX.Element => {
  return (
    <li className='sf__socialitem'>
      <a className="sf__sociallink" href={url} target='_blank' {...getTargetBlankProps(url)}>
        <span className="sr-text">{srText}</span>
        <svg width="24px" height="24px" aria-hidden="true"><use xlinkHref={`#icon--${slug}`} /></svg>
      </a>
    </li>
  )
}

export const itemPartner = (url: string, srText: string, slug: string, width: number): JSX.Element => {
  return (
    <li className='sf__logositem'>
      <a className="sf__logoslink" href={url} target='_blank' {...getTargetBlankProps(url)}>
        <span className="sr-text">{srText}</span>
        <img loading="lazy" fetchpriority="low" src={`https://giustoragev2.blob.core.windows.net/shoppinger/reuma-corpo/logo--${slug}.svg`} alt="" width={width} height={34} aria-hidden="true" />
      </a>
    </li>
  )
}
